import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const EditIcon = (props) => <FontAwesomeIcon icon={["fas", "edit"]} {...props}/>

export default EditIcon;